import Sidebar from "../components/shared/sidebar/Sidebar";
import { useSidebar } from "../context/SidebarContext";
import { motion } from "framer-motion";
import EnergoNavbar from "../components/shared/navbar/EnergoNavbar";
import { Outlet } from "react-router-dom";
import { MdDashboard } from "react-icons/md";
import { AiOutlineCloudDownload } from "react-icons/ai";
import { BsFillDeviceSsdFill } from "react-icons/bs";
import { BiSupport } from "react-icons/bi";
import { useAuthState } from "../context/AuthContext";

const PrivateLayout = () => {

    const { user } = useAuthState(); // Get user from AuthContext
    const { isExpanded, setIsExpanded } = useSidebar();
    const menuOptions = [
        { id: "dashboard", icon: <MdDashboard />, text: "Dashboard", link: "/dashboard/" },
        { id: "download", icon: <AiOutlineCloudDownload />, text: "Dokumente", link: "/dashboard/dokumente/" },
        { id: "anlagen", icon: <BsFillDeviceSsdFill />, text: "Meine Anlagen", link: "/dashboard/anlagen/" },
        { id: "support", icon: <BiSupport />, text: "Supportbereich", link: "/dashboard/support/" },
    ];

    const filteredMenuOptions = user?.x_document_preference === "Email"
        ? menuOptions.filter(opt => opt.id !== "download")
        : menuOptions;

    return (
        <>
            <Sidebar menuOptions={filteredMenuOptions} toggleSidebar={isExpanded} setToggleSidebar={setIsExpanded} />
            <motion.div 
                className="sb-content"
                animate={{ marginLeft: isExpanded ? 230 : 60 }}
                transition={{ duration: 0.3 }}
                style={isExpanded ? { marginLeft: 230 } : { marginLeft: 60 }} 
            >
                <EnergoNavbar menuOptions={menuOptions} />
                <main>
                    <Outlet />
                </main>
            </motion.div>
        </>
    )
}
export default PrivateLayout;